(() => {
  /* La bascule du menu a été déplacée dans `sbc-header.js` au lot 127 :
     ouverture, fermeture, voile, croix et focus forment un seul comportement
     et ne peuvent pas vivre dans deux fichiers. Laisser un second écouteur
     ici rejouerait la bascule à chaque clic (ouvert puis refermé aussitôt). */

  document.querySelectorAll('[data-sort-by], [data-catalogue-filter]').forEach((select) => select.addEventListener('change', () => {
    if (select.form) select.form.requestSubmit();
  }));
})();

/* SBC MOTION SYSTEM 2026 */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;
  root.classList.add('motion-ready');

  const revealOne = (element) => {
    element.classList.add('is-revealed');
  };

  const showProducts = () => {
    document.querySelectorAll('.product-grid,.sbc-search-simple__grid,.sbc-product-extras__track,.sbc-favorites-page__grid,.product-page').forEach((element) => {
      element.removeAttribute('data-sbc-stagger');
      element.removeAttribute('data-sbc-reveal');
      element.classList.add('is-revealed');
    });
  };
  showProducts();
  window.addEventListener('pageshow', showProducts);

  const staggerTargets = document.querySelectorAll('.proofbar,.universe-grid,.steps,.size-grid,.review-stack,.faq-list,.footer-grid');
  staggerTargets.forEach((container) => {
    container.dataset.sbcStagger = '';
    [...container.children].forEach((child, index) => child.style.setProperty('--sbc-index', index));
  });

  if (reduced || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-sbc-reveal],[data-sbc-stagger],.hero-copy').forEach(revealOne);
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealOne(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    document.querySelectorAll('[data-sbc-reveal],[data-sbc-stagger],.hero-copy').forEach((element) => observer.observe(element));
  }

  const header = document.querySelector('.site-header');
  if (header) {
    const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 18);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }
})();

/* SBC CART QUANTITY STEPPER — RETIRÉ EN V16

   Ce fichier construisait ses propres boutons − et + sur chaque ligne de
   panier, avec un drapeau de garde (`data-sbc-quantity-enhanced`) différent de
   celui de `sections/cart-ajax-fix.liquid` (`data-sbc-stepper`). Aucun des deux
   ne voyait l'autre : au chargement, chaque ligne recevait donc quatre boutons,
   d'où le « − − 1 + + » visible. Après un rendu Ajax, seul cart-ajax-fix se
   réinstallait et il n'en restait que deux — d'où des contrôles qui semblaient
   apparaître et disparaître selon les transitions.

   Ce module envoyait en plus le formulaire complet (`update`), soit un
   rechargement de page : un troisième pipeline de mutation, hors du pipeline
   canonique décrit dans docs/05_THEME_REQUIREMENTS.md §14.

   Le stepper, son CSS et ses écouteurs vivent désormais uniquement dans
   `sections/cart-ajax-fix.liquid`. Le module « scroll memory » qui
   l'accompagnait servait à survivre au rechargement provoqué par cet envoi de
   formulaire ; il disparaît avec lui. */
